var _linearGradient, _linearGradient2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinsbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(0 -21.9345 21.9345 0 32.9813 19.9778)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb9112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fb9c2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fbb869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbdbb5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(29.3759 5.1788 -5.1788 29.3759 7.73151 22.1074)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb9112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbdbb5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.47359 0 0 5.47359 29.9987 163.522)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#33323e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m85.027.919h-5.244v-.919h11.565v.919h-5.243v13.081h-1.062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.869 0h.913v14h-.913z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.047 7.959c.55.6.824 1.38.823 2.341 0 1.186-.452 2.099-1.354 2.74-.902.64-2.242.96-4.018.96h-6.498v-14h6.08c1.585 0 2.817.31 3.698.93s1.322 1.503 1.322 2.649c.025.725-.207 1.437-.657 2.02-.454.559-1.076.971-1.781 1.181 1.042.193 1.837.586 2.385 1.179zm-9.985-7.079v5.581h4.978c1.275 0 2.257-.237 2.945-.711s1.032-1.171 1.032-2.09c0-.908-.344-1.598-1.032-2.07-.688-.471-1.67-.708-2.945-.71zm8.657 11.53c.729-.473 1.094-1.202 1.094-2.188s-.365-1.716-1.094-2.188c-.729-.468-1.801-.702-3.217-.7h-5.44v5.787h5.436c1.408 0 2.48-.237 3.216-.711z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.882 13.471c-.841-.277-1.604-.739-2.23-1.349l.48-.744c.572.556 1.264.983 2.026 1.25.852.323 1.76.487 2.675.483 1.36 0 2.386-.249 3.078-.748.659-.439 1.049-1.166 1.039-1.94.029-.544-.17-1.077-.55-1.478-.384-.378-.85-.667-1.365-.847-.72-.247-1.456-.451-2.202-.61-.85-.2-1.687-.449-2.506-.746-.622-.229-1.175-.605-1.609-1.093-.446-.492-.669-1.152-.669-1.981-.005-.652.186-1.292.551-1.841.412-.594.997-1.057 1.681-1.33.894-.355 1.855-.523 2.822-.494.787 0 1.57.113 2.322.337.706.196 1.374.503 1.978.907l-.388.806c-.576-.382-1.212-.674-1.884-.862-.657-.194-1.341-.294-2.028-.297-1.318 0-2.317.256-2.996.769-.654.464-1.034 1.206-1.019 1.99-.026.543.172 1.073.551 1.474.381.378.845.667 1.357.847.73.25 1.475.461 2.229.63.851.192 1.689.436 2.508.73.614.231 1.163.6 1.598 1.078.446.479.669 1.128.669 1.94.006.651-.189 1.289-.559 1.832-.428.595-1.027 1.055-1.724 1.322-.905.351-1.875.518-2.85.491-1.021.004-2.032-.174-2.985-.526z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.652 0v14h-.897l-10.188-12.16v12.158h-1.089v-13.998h.919l10.167 12.158v-12.158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.604 4.383h.991v4.907h-.991z",
    fillOpacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.617 13.097c-1.102-.586-2.017-1.452-2.649-2.505-.651-1.09-.986-2.331-.967-3.59-.019-1.259.316-2.498.967-3.588.632-1.052 1.547-1.918 2.649-2.504 1.16-.617 2.465-.93 3.788-.909.971-.009 1.935.155 2.845.483.846.306 1.608.795 2.228 1.431l-.653.647c-1.148-1.087-2.611-1.632-4.389-1.633-1.139-.014-2.261.257-3.26.787-.959.509-1.755 1.264-2.301 2.182-.562.943-.851 2.015-.836 3.104-.015 1.09.274 2.163.836 3.107.545.918 1.342 1.672 2.301 2.179.998.532 2.121.804 3.26.79 1.765 0 3.224-.553 4.378-1.657l.653.647c-.621.637-1.383 1.129-2.228 1.439-.908.333-1.872.5-2.843.492-1.319.021-2.621-.29-3.779-.902z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m22 14c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z",
    fill: "#9c7c4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 14c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z",
    fill: "#9c7c4d",
    fillOpacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 14c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7z",
    fill: "url(#a)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.443 13.016c-3.345-1.872-5.21-6.219-3.331-9.551.688-1.22 2.775-3.707 4.698-4.1 1.578-.322 5.98 1.616 5.98 1.616z",
    fill: "url(#b)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.004 9.148c.852 2.03 2.854 3.351 5.073 3.347 3.017-.009 5.461-2.43 5.47-5.419.005-2.198-1.329-4.182-3.378-5.025s-4.409-.38-5.978 1.175c-1.569 1.554-2.038 3.892-1.187 5.922zm.576-2.083c0-2.46 2.013-4.454 4.497-4.454 2.482.002 4.494 1.995 4.496 4.454 0 2.461-2.013 4.455-4.496 4.455-2.484 0-4.497-1.994-4.497-4.455z",
    fill: "#fff",
    fillOpacity: 0.61
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsbit);
export default __webpack_public_path__ + "static/media/coinsbit.f09e1e9de11efb11359fd85c12b1934d.svg";
export { ForwardRef as ReactComponent };